import { last } from "lodash";
import ProfilesPage from "PFApp/profiles/list/profiles_page";
import ShowMore from "PFApp/profiles/list/show_more";
import { LoadingDots } from "PFComponents/loading_dots";
import { useQueryParams } from "PFCore/helpers/use_query_params";
import useStorage from "PFCore/helpers/use_storage";
import { useProfilesInfinite } from "PFCore/hooks/queries/profiles/use_profiles_infinite";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { getAPIFilters } from "../../use_filtered_collection/format_filters";

const perPage = 50;

const ProfilesController = () => {
  const history = useHistory();
  const location = useLocation();
  const params = useQueryParams();

  const currentPage = Number(params.get("page")) || 1;

  const [filters, setFilters] = useStorage(
    "profilesLastSelectedFilters",
    {},
    {
      expiresIn: 60 * 60
    }
  );

  const [order, setOrder] = useStorage("profilesLastSelectedOrder_1", null, {
    expiresIn: 60 * 60
  });

  const [previousData, setPreviousData] = useState(null);
  const { data, isFetching, fetchNextPage } = useProfilesInfinite({
    page: currentPage,
    per_page: perPage,
    filters: location.state?.filters || filters,
    ...(order ? { order } : {}),
    nested: true
  });

  useEffect(() => {
    if (data) {
      setPreviousData(data);
    }
  }, [data]);

  const currentData = data || previousData;
  const meta = last(currentData?.pages || [])?.meta;
  const entries = currentData?.pages.map(({ entries }) => entries).flat();

  const handleFiltersCollectionChange = (filters) => {
    history.push({
      path: "/profiles",
      search: "?page=1"
    });

    setFilters(getAPIFilters(filters));
  };

  const handleOrderChange = (order) => {
    history.push({
      path: "/profiles",
      search: "?page=1"
    });
    setOrder(order);
  };

  if (!currentData) {
    return <LoadingDots circlesEnabled pageViewEnabled />;
  }

  return (
    <ProfilesPage
      loading={isFetching}
      meta={meta}
      profiles={entries}
      pagination={<ShowMore currentPage={meta.page} totalPages={meta.totalPages} onClick={fetchNextPage} />}
      handleFiltersCollectionChange={handleFiltersCollectionChange}
      handleOrderChange={handleOrderChange}
    />
  );
};

export default ProfilesController;
